import { ProfileFieldModel } from "@/domains/profile/models/ProfileFieldModel";

export function ProfileTabModel(data) {
    const { id, name, type, sort, profileFields } = data;

    const fields = [...profileFields];
    fields.sort((a, b) => a.sort - b.sort);

    return {
        id,
        name,
        profileSection: `${type}`,
        sort,
        fields: fields.map(ProfileFieldModel),
        opened: fields.length,
    };
}

export function updateProfileTabData(tab, data) {
    if (!tab) return;
    const { name } = data;
    tab.name = name;
}

export function addProfileTabField(tab, fieldData) {
    if (!tab) return;
    tab.fields.push(ProfileFieldModel(fieldData));
    tab.opened = true;
}

export function updateProfileTabField(tab, fieldData) {
    if (!tab) return;
    tab.fields = tab.fields.map((field) => {
        if (field.id === fieldData.id) return ProfileFieldModel(fieldData);
        return field;
    });
}

export function removeProfileTabField(tab, fieldId) {
    if (!tab) return;
    tab.fields = tab.fields.filter((field) => field.id !== fieldId);
    if (!tab.fields.length) tab.opened = false;
}
